<div class="slds-brand-band slds-brand-band_large">
  <div class="center">
    <h1>ERROR : 404</h1>
    <h3>PAGE NOT FOUND!!!</h3>
  </div>
  <img class="pfn-img" alt="Page Not Found Img" src={{img}} />
</div>
